import { Panel, PanelType } from "@fluentui/react/lib/Panel";
import { Label, Link, Stack } from "@fluentui/react";
import { Ev2ExperimentStage } from "../../../../Types";
import { styles as sharedStyles } from "../../../../Shared/shared.styles";
import RolloutDetailsPanelStagesList from "./RolloutDetailsPanelStagesList";
import useAppInsights from "../../../../Hooks/UseAppInsights";
import { NavType } from "../../../../Shared/AppInsights";

interface RolloutDetailsEv2PanelProps {
  /**
   * Array of EV2 experiment stages with status and details
   */
  ev2Stages: Ev2ExperimentStage[];
  /**
   * Base URL for EV2 portal links
   */
  ev2BaseLink: string;
  /**
   * Number of variants in the ABN experiment, used to determine if we should show A/B/n or A/B template in the panel
   */
  abnVariantCount?: number;
  /**
   * Callback used when user dismisses the panel
   */
  onCancel: () => void;
}

/**
 * A side panel component that displays EV2 rollout details including rollout ID and stages
 * Provides a link to the EV2 portal for external access
 */
const RolloutDetailsEv2Panel: React.FC<RolloutDetailsEv2PanelProps> = ({
  ev2Stages,
  ev2BaseLink,
  abnVariantCount,
  onCancel,
}) => {
  const rolloutId = ev2BaseLink.split("/").pop() || "";
  const { trackNavigationEvent } = useAppInsights("RolloutDetailsEv2Panel");
  return (
    <Panel
      isOpen={true}
      type={PanelType.medium}
      onRenderHeader={() => (
        <Stack className={sharedStyles.panelHeader}>
          <Label className={sharedStyles.panelHeaderLabel}>EV2 Overview</Label>
        </Stack>
      )}
      onDismiss={onCancel}
      isLightDismiss={true}
    >
      <Stack tokens={{ childrenGap: 16 }}>
        <Stack>
          <Label>
            Rollout ID:{" "}
            <Link
              href={ev2BaseLink}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                trackNavigationEvent({
                  destination: ev2BaseLink,
                  navType: NavType.External,
                });
              }}
            >
              {rolloutId}
            </Link>
          </Label>
        </Stack>
        <RolloutDetailsPanelStagesList
          ev2Stages={ev2Stages}
          ev2BaseLink={ev2BaseLink}
          abnVariantCount={abnVariantCount}
        />
      </Stack>
    </Panel>
  );
};

export default RolloutDetailsEv2Panel;
